import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { AppNgMaterialModule } from '../../app-ng-material.module';
import { AppNgAppkitModule } from '../../app-ng-appkit.module';
import { CoreModule } from '../core.module';
import { SharedDirectivesModule } from '../../shared/_directives/shared-directives.module';

import { ExDashboardComponent } from './ex-dashboard.component';
import { ExComponentContainerComponent } from './components/ex-component-container/ex-component-container.component';
import { ExChartComponent } from './components/ex-chart/ex-chart.component';
import { ExComponentResolverComponent } from './components/ex-component-resolver/ex-component-resolver.component';
import { ExComponentHost } from './components/ex-component-resolver/ex-component-resolver.directive';
import { HorizontalBusinessGroupComponent } from './components/ex-horizontal-business-group/ex-horizontal-business-group.component';
import { ExKPIComponent } from './components/ex-kpi/ex-kpi.component';
import { ExDatatableComponent } from './components/ex-datatable/ex-datatable.component';
import { ExProjectReviewComponent } from './components/ex-project-review/ex-project-review.component';
import { BusinessSignOffComponent } from './components/business-sign-off/business-sign-off.component';
import { BusinessSignOffEditComponent } from './components/business-sign-off-edit/business-sign-off-edit.component';
import { RawDataDialogComponent } from './components/raw-data-dialog/raw-data-dialog.component';
import { EditComponentDialogComponent } from './components/edit-component-dialog/edit-component-dialog.component';
import { StrategyFunctionDialogComponent } from './components/strategy-function-dialog/strategy-function-dialog.component';

import { ConvertAmountPipe } from './pipes/convert-amount.pipe';
import { OrderByPipe } from './pipes/order-by.pipe';
import { SafeHtmlPipe } from './pipes/safe-html.pipe';
import { FilterFnPipe } from './pipes/filter-fn.pipe';
import { SharedPipesModule } from '../../shared/pipes/shared-pipe.module';

@NgModule({ declarations: [
        ExDashboardComponent,
        ExComponentContainerComponent,
        ExChartComponent,
        ExComponentResolverComponent,
        ExComponentHost,
        HorizontalBusinessGroupComponent,
        ExKPIComponent,
        ExDatatableComponent,
        ExProjectReviewComponent,
        BusinessSignOffComponent,
        BusinessSignOffEditComponent,
        RawDataDialogComponent,
        EditComponentDialogComponent,
        StrategyFunctionDialogComponent,
        ConvertAmountPipe,
        OrderByPipe,
        SafeHtmlPipe,
        FilterFnPipe],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    exports: [
        ExDashboardComponent,
        ExComponentContainerComponent,
        ExComponentResolverComponent], imports: [CommonModule,
        FormsModule,
        MatDialogModule,
        AppNgMaterialModule,
        AppNgAppkitModule,
        CoreModule,
        SharedDirectivesModule,
        SharedPipesModule], })
export class ExDashboardModule {}
